var _a, _b;
import isEmpty from 'lodash/isEmpty';
import isPlainObject from 'lodash/isPlainObject';
import getConfig from 'next/config';
import { stringify } from '@src/utils/qs';
const pixelHost = ((_a = getConfig()) === null || _a === void 0 ? void 0 : _a.publicRuntimeConfig.pixelHost) || process.env.PIXEL_HOST || '';
const pixelNabooHost = ((_b = getConfig()) === null || _b === void 0 ? void 0 : _b.publicRuntimeConfig.pixelNabooHost) ||
    process.env.PIXEL_NABOO_HOST ||
    '';
const objectToFormData = (data, fd, namespace) => {
    const formData = fd || new FormData();
    return data
        ? Object.keys(data).reduce((acc, key) => {
            if (isPlainObject(data[key])) {
                objectToFormData(data[key], formData, key);
            }
            else {
                const formDataKey = namespace ? `${namespace}[${key}]` : key;
                acc.append(formDataKey, data[key]);
            }
            return acc;
        }, formData)
        : null;
};
/**
 * There is a bug with Chrome not setting the correct
 * Content-Type: application/x-www-form-urlencoded.
 * Firefox and Safari are both working.
 * https://bugs.chromium.org/p/chromium/issues/detail?id=747787
 * Implemented a workaround by sending multipart/form-data.
 */
export const sendBeacon = ({ path, query, data, host = pixelNabooHost, }) => {
    if (navigator.sendBeacon) {
        const q = query
            ? Object.entries(query)
                .filter(([, val]) => val !== undefined)
                .reduce((acc, [key, value]) => (Object.assign(Object.assign({}, acc), { [key]: value })), {})
            : {};
        const formData = objectToFormData(data);
        const success = navigator.sendBeacon(`${host}${path}${stringify(q, { addQueryPrefix: true })}`, formData);
        return Promise.resolve(success);
    }
    return Promise.reject();
};
export const sendBeaconPixel = ({ path, data, host = pixelHost, }) => {
    if (navigator.sendBeacon) {
        try {
            const jsonData = JSON.stringify(data);
            // multipart/form-data
            const formData = new FormData();
            formData.append('_json', encodeURI(jsonData));
            if (isEmpty(formData.get('_json'))) {
                throw Error('Empty payload');
            }
            const url = `${host}${path}`;
            const success = navigator.sendBeacon(url, formData);
            return Promise.resolve(success);
        }
        catch (err) {
            return Promise.reject();
        }
    }
    return Promise.reject();
};
